import { FormControl, FormGroup } from '@angular/forms';

export type PublicSubscriptionControls = {
  cardChargeDay: FormControl<number>;
};

export class PublicSubscriptionForm {
  public constructor(
    private readonly data: {
      cardChargeDay: number;
    },
  ) {}

  public get cardChargeDay(): number {
    return this.data.cardChargeDay;
  }
}

/* prettier-ignore */
export type PublicSubscriptionFormGroup = FormGroup<PublicSubscriptionControls>;
